export interface TRBStatusTableRow {
    fc: string;
    cpt: string;
    cptUTC: string;
    timeToCPT: string;
    timeToCPTSeconds: number;
    lowThreshold: string;
    highThreshold: string;
    risk: string;
    shipOption: string;
    processPathGroup: string;
}

export interface TRBMaxRiskTableRow {
    fc: string;
    cpt: string;
    cptUTC: string;
    timeToCPT: string;
    timeToCPTSeconds: number;
    lowThreshold: string;
    highThreshold: string;
    highThresholdMinusRisk: string;
    risk: string;
    shipOption: string;
    processPathGroup: string;
}

export interface TRBFCProcessingTimes {
    [fc: string]: {
        [shipOption: string]: number;
    };
}

export interface TRBSnapshotUrls {
    cptSnapshotUrl: string;
    r2fSnapshotUrl: string;
}

export const TRB_REGIONS = ['NA', 'ZAZ', 'FE'];
